//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export abstract class WebsiteBlockRenderContextDisplayItem extends ItemBase {
    Jwt: string | null = null;
    CaptchaRequired: boolean = false;

    static readonly ClassName: string = "WebsiteBlockRenderContextDisplayItem";
}
